import { Stack } from '@mui/material';

import { useScrollable } from './useScrollable';

export const ScrollableHeader = ({
  children,
  hideBorderWhenOnTop,
}: {
  children: React.ReactNode;
  hideBorderWhenOnTop?: boolean;
}) => {
  const { isScrolledVertically } = useScrollable();

  return (
    <Stack
      sx={{
        borderBottom: hideBorderWhenOnTop
          ? 'none'
          : '1px solid var(--mui-palette-divider)',
        boxShadow: isScrolledVertically
          ? '0px 10px 30px 0px rgba(0, 0, 0, 0.10)'
          : undefined,
      }}
    >
      {children}
    </Stack>
  );
};
